module.exports = __webpack_public_path__ + "img/my_head_bg.264e70c9.png";